import Transformer from "./../transformer";

export default class materialTransformer extends Transformer {
  static fetch(material) {
    return {
      id: material.id,
      requisition: material.requisition,
      requisitionFolio: material.requisition_folio,
      sinisterRequisition: material.sinister_req ? material.sinister_req : 'Sin Requisición',
      unitPrice: material.unit_price,
      isActive: material.is_active,
      // Material -> object
      materialId: material.material.id,
      materialStatus: material.material.status.name,
      materialQuantity: material.material.quantity,
      materialUnitPrice: material.material.unit_price,
      supplyCode: material.material.supply.code,
      supplyId: material.material.supply.id,
      supplyName: material.material.supply.name,
      supplyUnitMeasurement: material.material.supply.unit_measurement,
    };
  }
}



// WEBPACK FOOTER //
// ./src/transformers/purchase/materials.js